module.exports = "/assets/packs/images/1f14b852a614069fecc64261b55d6466.png";